/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Budget_MinInputs */

const cs_requirements_budget_min = /** @type {(inputs: Requirements_Budget_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpočet od`)
};

const en_requirements_budget_min = /** @type {(inputs: Requirements_Budget_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget min`)
};

/**
* | output |
* | --- |
* | "Budget min" |
*
* @param {Requirements_Budget_MinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_budget_min = /** @type {((inputs?: Requirements_Budget_MinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Budget_MinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_budget_min(inputs)
	return cs_requirements_budget_min(inputs)
});